import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {AspectRatio} from "@/lib/components/flexible/enum/AspectRatio";
import {PropType} from "vue";


export default /*#__PURE__*/_defineComponent({
  name: 'AspectRatioedElement',
  props: {
  ratio: String as PropType<AspectRatio>,
  customClass: String,
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "606fa157": (_unref(aspectRatio)),
  "fa3820ec": (_unref(width))
}))




const aspectRatio = props.ratio ? props.ratio : "initial",
    width = aspectRatio === "initial" ? "100%" : "initial";


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('aspect-ratioed ' + __props.customClass)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})